import { EventEmitter, Injectable, Output } from '@angular/core';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
import firebase from 'firebase/app';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable, combineLatest } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { resolveDefinition } from '@angular/core/src/view/util';
import { Http, Headers, RequestOptions } from '@angular/http';
import { EnvDataService } from '../../../app/services/env-data-service';

// import {User} from '../models/user.model';
// import {Contact} from '../models/contact.model';
@Injectable()
export class ADFFormService {

  public userRole: any;
  public deleted_access: any;
  public housingsituation:any;
  // @Output() user_data=new EventEmitter<any>();
  // userCollection: AngularFirestoreCollection<User>;
  // contactCollection: AngularFirestoreCollection<Contact>;
  // contactItem: Observable<Contact[]>;
  constructor(
    public db: AngularFirestore,
    private EnvDataService: EnvDataService,
    private _http:Http
  ) {
  }

  // // get user details by sending form document id

  //   userdetailsbyadfid(SDF_form_document_id)
  //   {
  //       console.log(SDF_form_document_id);
  //       let thiss = this;
  //       return new Promise((resolve, reject) => {
  //         let SDF_form = firebase.firestore().collection("SDF_form").doc(SDF_form_document_id);

  //         let user_collections : any;
  //         let primary_applicant: any;
  //         let secondary_applicant:any;

  //         SDF_form.get().then(function(SDF_form_doc) {
  //             if (SDF_form_doc.exists) {
  //                 let sdf_data = SDF_form_doc.data();
  //                 let main_uid = sdf_data.uid;
  //                 main_uid ='rr8EbQQs2nR22RkN93zeMEefusR2';
  //                 SDF_form_document_id = 'rr8EbQQs2nR22RkN93zeMEefusR2_1596114405140';
  //                 let docRef1 = firebase.firestore().collection("users").doc(main_uid);
  //                 docRef1.get().then(function(doc) {
  //                     thiss.get_first_user_data(SDF_form_document_id, main_uid).subscribe((data)=>{
  //                         //console.log(data);
  //                         primary_applicant = data
  //                         let primary_data = doc.data();
  //                         user_collections = {
  //                           primary_data:primary_data,
  //                           primary_details:primary_applicant[0]

  //                       }
  //                       //return user_collections;
  //                       resolve(user_collections);
  //                     });


  //                 },(err) => {
  //                     reject(err);
  //                 })
  //             }
  //         })
  //       }).then((user_collections) => {

  //         return new Promise((resolve, reject) => {

  //           thiss.get_second_user_data(SDF_form_document_id).subscribe((result)=>{

  //             let array_result =[];
  //             const requests = result.map(function (data) {

  //               const promise = new Promise(function (resolve, reject) {

  //                 firebase.firestore().collection("users").doc(data.uid).get().then((userresult) =>{
  //                    let users = userresult.data();
  //                     let user_object = {
  //                        secondary_data : users,
  //                        secondary_details:data
  //                     }
  //                     array_result.push(user_object);
  //                     resolve(true);
  //                 });



  //               })
  //               return promise;



  //           });
  //             Promise.all(requests).then(function (result) {
  //                 //console.log(finalexams);
  //                 console.log(array_result);
  //                 console.log(user_collections);

  //                 let final_result = {
  //                   primary_applicant:user_collections,
  //                   secondary_applicant:array_result
  //                 }

  //                 resolve (final_result);

  //             })

  //           });

  //         })

  //       })

  //   }


  //   // get users table data by sending email id

    getUsersDataByUser(user_id) {

      let thiss = this;
      //email_id = 'kmFMykdLSmpjdOy10TnP'
      return new Promise((resolve, reject) => {

        firebase.firestore().collection("users").where('uid', '==', user_id).get().then(function (querySnapshot2) {
          let user_data;
          querySnapshot2.forEach(function (contDoc) {
           user_data = contDoc.data();
          })
          resolve(user_data);
        })

      })

    }

  // save applicant contact list data

  saveApplicantDetails(applicant_object) {

    //saving primary applicant data

    //  applicant_object = {
    //        user_data:{


    //          firstname:'first 1',
    //          lastname:'testing 1',
    //          email: 'sultantest11@gmail.com',
    //          mobile_phone: '126543',
    //          password:  '1236547885',
    //          deleted:0,
    //          created_date: new Date().getTime(),
    //          roles:{


    //            contact:true
    //          }

    //        },
    //    }

    return new Promise((resolve, reject) => {

      this.checkuserexist(applicant_object.user_data).then((data: any) => {

        if (!data.status) {

          firebase.firestore().collection("users").add(applicant_object.user_data)
            .then(function (docRef) {

              // console.log(docRef)
              // console.log(docRef.id);
              let user_id = docRef.id;
              let newuser = applicant_object.user_data;
              newuser.uid = user_id;
              firebase.firestore().collection("users").doc(user_id).set(newuser).then(function (querySnapshot2) {

                if (applicant_object.contact_details) {
                  applicant_object.contact_details.uid = docRef.id;
                  console.log('its is okay');
                  firebase.firestore().collection("contact_details").add(applicant_object.contact_details).then(function (details) {
                    console.log(details);
                    let message = "applicant added successfully";

                    let result = {
                      message: message,
                      uid: docRef.id,
                      status: true
                    }
                    resolve(result);
                  })
                }
                else {
                  console.log('its is not okay');
                  let message = "applicant added successfully";

                  let result = {
                    message: message,
                    uid: docRef.id,
                    status: true
                  }
                  resolve(result);
                }
              })

            })

        }
        else {
          resolve(data)
        }

      });

    })

  }

  // get applicant contact list data by sending uid

  checkuserexist(user_data: any) {

    let thiss = this;

    let promise =  new Promise(function (resolve, reject) {


      //thiss.get_users_table_data(email).subscribe((data)=>{
      firebase.firestore().collection("users").where('email', '==', user_data.email).get().then(function (querySnapshot2) {
        let flag = 0;
        let users:any;
        querySnapshot2.forEach(function (contDoc) {
          flag = 1;
          users = contDoc.data();
        })
        if (flag == 0) {

          let postData = {
            'email': user_data.email,
            'password': user_data.password
          }
          //console.log(postData);
         // var url = "https://us-central1-sync-afy-dev-sandbox.cloudfunctions.net/createAdfUser";
          var url = thiss.EnvDataService.EnvData.sendbox_api +"/createAdfUser";
          var headers = new Headers();
          headers.append("Accept", 'application/json');
          headers.append('Content-Type', 'application/json' );
          const requestOptions = new RequestOptions({ headers: headers });

          thiss._http.post(url, postData, requestOptions).toPromise()
          .then(data => {
            let newuser =JSON.parse(data['_body']);
            console.log(newuser);
            if(newuser.status == 'success'){

              firebase.firestore().collection("users").doc(user_data.reference_broker).get().then(function (brokersnap) {

                firebase.firestore().collection("analytics").where('id','==',1).get().then(function (querySnapshot3) {

                  querySnapshot3.forEach(function (anaDoc) {

                    anaDoc.ref.update({
                      total_users:firebase.firestore.FieldValue.increment(1)
                    });
                  })

                  console.log(newuser.user.uid);
                  let message = "User is not found.";
                  let result = {
                    message: message,
                    uid:newuser.user.uid,
                    broker_data:brokersnap.data(),
                    status: false
                  }
                  resolve(result);

                })



              })

            }
          }, error => {
            console.log(error.message);

          })

        //   firebase.auth().createUserWithEmailAndPassword(user_data.email, user_data.password).then(function(userresult) {

        //     console.log(userresult);
        //     let message = "User is not found.";

        //     let email = 'developer.rspl@gmail.com';
        //     let password = '123456';
        //     firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
        //       // Handle Errors here.
        //       var errorCode = error.code;
        //       var errorMessage = error.message;
        //       // ...
        //     });

        //     let result = {
        //       message: message,
        //       uid:userresult.user.uid,
        //       status: false
        //     }
        //     resolve(result);

        //   }).catch(error => {
        //     switch (error.code) {
        //        case 'auth/email-already-in-use':
        //          //console.log(`Email address ${this.state.email} already in use.`);
        //          let message = "User is found.";

        //          let result = {
        //            message: message,
        //            status: false
        //          }
        //          resolve(result);

        //          break;
        //       //  case 'auth/invalid-email':
        //       //    console.log(`Email address ${this.state.email} is invalid.`);
        //       //    let message = `Email address ${this.state.email} is invalid.`;

        //       //    let result = {
        //       //      message: message,
        //       //      status: false
        //       //    }
        //       //    resolve(result);

        //       //    break;
        //       //  case 'auth/operation-not-allowed':
        //       //    console.log(`Error during sign up.`);
        //       //    break;
        //       //  case 'auth/weak-password':
        //       //    console.log('Password is not strong enough. Add additional characters including special characters and numbers.');
        //       //    break;
        //       //  default:
        //       //    console.log(error.message);
        //       //    break;
        //      }
        //  });


          // firebase.firestore().collection("users").where('mobile_phone', '==', user_data.mobile_phone).get()
          //   .then(function (querySnapshot2) {
          //     let flag = 0;
          //     querySnapshot2.forEach(function (contDoc) {
          //       flag = 1;
          //     })
          //     if (flag == 0) {

          //       firebase.auth().createUserWithEmailAndPassword(user_data.email, user_data.password).then(function(error) {

          //         let message = "User is not found.";

          //       let result = {
          //         message: message,
          //         status: false
          //       }
          //       resolve(result);

          //       });


          //     }
          //     else {
          //       let message = "Phone number is already exists";

          //       let result = {
          //         message: message,
          //         status: true
          //       }
          //       resolve(result);
          //     }
          //   })
        }
        else {

          firebase.firestore().collection("users").doc(user_data.reference_broker).get().then(function (brokersnap) {

            let message = "Email is already exists";
              let result = {
                message: message,
                password:users.password,
                uid:users.uid,
                broker_data:brokersnap.data(),
                users:users,
                status: true
              }
              resolve(result);

          })


        }
      })

    })
    return promise;
  }
  deleteApplicantDetails(user_id) {
    //console.log('sdgj');
    //debugger;
    // user_id = 'nrDWekkC0QaEhfp4Xibh';

    return new Promise((resolve, reject) => {

      firebase.firestore().collection("users").doc(user_id).update({ deleted: 1 }).then(function () {
        // console.log("Document 1 successfully deleted!");
        let flag = 0;
        firebase.firestore().collection("contact_details").where('uid', '==', user_id).get().then(querySnapshot2 => {
          querySnapshot2.forEach((doc) => {
            flag = 1;
            doc.ref.update({ deleted: 1 });
            //console.log("Document 2 successfully deleted!");
          });
        })

        let message = "Document successfully deleted!";
        let result = {
          status: true,
          message: message
        }
        resolve(result)

      }).catch(function (error) {
        console.error("Error removing document: ", error);

        let message = "Error removing document: " + error;
        let result = {
          status: false,
          message: message
        }
        resolve(result)
      });

    })

    //console.log(user_data);

  }

  update_applicant_details(upcoming_object, user_id) {
    console.log(upcoming_object);
    console.log(user_id);
    //debugger;
    let children_arr = [];
    let children_length = parseInt(upcoming_object.how_many_children);
    for (let i = 0; i < children_length; i++) {

      if (i == 0) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.first_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 1) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.second_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 2) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.third_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 3) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.fourth_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 4) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.fifth_child_age)
        }
        children_arr.push(children_object);
      }

    }

    let previous_array = [
      {
        address_type: this.replaceUndefinied(upcoming_object.address_type),
        address_format: this.replaceUndefinied(upcoming_object.address_format),
        full_address: this.replaceUndefinied(upcoming_object.full_address),
        floor_number: this.replaceUndefinied(upcoming_object.floor_number),
        unit_number: this.replaceUndefinied(upcoming_object.unit_number),
        building_name: this.replaceUndefinied(upcoming_object.building_name),
        street_number: this.replaceUndefinied(upcoming_object.street_number),
        street_name: this.replaceUndefinied(upcoming_object.street_name),
        street_type: this.replaceUndefinied(upcoming_object.street_type),
        poboxlabel: this.replaceUndefinied(upcoming_object.poboxlabel),
        city: this.replaceUndefinied(upcoming_object.city),
        state: this.replaceUndefinied(upcoming_object.state),
        postcode: this.replaceUndefinied(upcoming_object.postcode),
        country: this.replaceUndefinied(upcoming_object.country),
        housing_situation: this.replaceUndefinied(upcoming_object.housing_situation),
        move_in_date: this.replaceUndefinied(upcoming_object.move_in_date),
        type: "current"
      },
    ];
    upcoming_object.addPreviousAddressItem.forEach(element => {
      let add_obj = {
        deleted: element.deleted,
        address_format: this.replaceUndefinied(element.previous_address_format),
        address_type: this.replaceUndefinied(element.previous_address_type),
        building_name: this.replaceUndefinied(element.previous_building_name),
        city: this.replaceUndefinied(element.previous_city),
        country: this.replaceUndefinied(element.previous_country),
        floor_number: this.replaceUndefinied(element.previous_full_address),
        full_address: this.replaceUndefinied(element.previous_full_address),
        housing_situation: this.replaceUndefinied(element.previous_housing_situation),
        move_in_date: this.replaceUndefinied(element.previous_move_in_date),
        move_out_date: this.replaceUndefinied(element.previous_move_out_date),
        poboxlabel: this.replaceUndefinied(element.previous_poboxlabel),
        postcode: this.replaceUndefinied(element.previous_postcode),
        state: this.replaceUndefinied(element.previous_state),
        street_name: this.replaceUndefinied(element.previous_street_name),
        street_number: this.replaceUndefinied(element.previous_street_number),
        street_type: this.replaceUndefinied(element.previous_street_type),
        unit_number: this.replaceUndefinied(element.previous_unit_number),
        type: "previous"
      }

      previous_array.push(add_obj);

    });

    let applicant_object = {
      user_data: {

        firstname: this.replaceUndefinied(upcoming_object.firstname),
        lastname: this.replaceUndefinied(upcoming_object.lastname),
        email: this.replaceUndefinied(upcoming_object.email),
        mobile_phone: this.replaceUndefinied(upcoming_object.mobile_phone),
        date_of_birth: this.replaceUndefinied(upcoming_object.date_of_birth),
        reference_broker: this.replaceUndefinied(upcoming_object.reference_broker),
        password: this.replaceUndefinied(upcoming_object.password),
        deleted: 0,
        created_date: new Date().getTime(),
        roles: {
          contact: true
        },
        uid: user_id
      },
      contact_details: {

        dependent: {

          gender: this.replaceUndefinied(upcoming_object.gender),
          current_marital_status: this.replaceUndefinied(upcoming_object.current_marital_status),
          do_you_have_children: this.replaceUndefinied(upcoming_object.do_you_have_children),
          how_many_children: this.replaceUndefinied(upcoming_object.how_many_children),
          children_age: children_arr
        },
        address: previous_array,
        employment_details:
        {
          employementType: this.replaceUndefinied(upcoming_object.employementType),
          start_date: this.replaceUndefinied(upcoming_object.start_date),
          currentlyEmployment: this.replaceUndefinied(upcoming_object.currentlyEmployment),
          expectFindWork: this.replaceUndefinied(upcoming_object.expectFindWork),
          statusyourEmployment: this.replaceUndefinied(upcoming_object.statusyourEmployment),
          your_occupation: this.replaceUndefinied(upcoming_object.your_occupation),
          business_name: this.replaceUndefinied(upcoming_object.business_name),
          type_of_entity: this.replaceUndefinied(upcoming_object.type_of_entity),
          addPrimaryEmploymentItem: this.replaceUndefinied(upcoming_object.addPrimaryEmploymentItem),
          abn_acn: this.replaceUndefinied(upcoming_object.abn_acn),
          nature_of_business: this.replaceUndefinied(upcoming_object.nature_of_business),
          created_date: new Date().getTime(),
          deleted: 0,
          incomes: upcoming_object.itemRows,
        },

        uid: user_id,
        deleted: 0,
        created_date: new Date().getTime(),
        roles: {
          contact: true
        }
      }
    }

    console.log('upcoming_object', upcoming_object);
    console.log('applicant_object', applicant_object);
    //debugger;
    return new Promise((resolve, reject) => {

      firebase.firestore().collection("users").doc(user_id).set(applicant_object.user_data).then(function (querySnapshot2) {
        if (applicant_object.contact_details) {

          firebase.firestore().collection("contact_details").where('uid', '==', user_id).get().then(response => {
            let batch = firebase.firestore().batch()
            let flag = 0;
            response.docs.forEach((doc) => {
              flag = 1;
              console.log('found');
              const docRef = firebase.firestore().collection("contact_details").doc(doc.id)
              batch.update(docRef, applicant_object.contact_details)
            })
            batch.commit().then(() => {
              //console.log(`updated all documents inside contact_details`);
            })
            if (flag == 0) {
              firebase.firestore().collection("contact_details").add(applicant_object.contact_details).then(function (details) {
                //console.log('working');
              })
            }

          })
        }
        let message = 'updated all documents inside contact_details';
        let result = {
          status: 'success',
          message: message
        }
        resolve(result)


      })
    })
  }

  replaceUndefinied(item) {
    if (item == undefined) {
      return '';
    }
    else {
      return item;
    }
  }
  replaceZero(item) {
    if (item == undefined) {
      return 0;
    }
    else {
      return item;
    }
  }

  checkolddata(item) {
    if (item == undefined) {
      return '';
    }
    else if(item == 0) {
      return '';
    }
    else {
      return item;
    }
  }

  getApplicantDetails(user_id) {

    console.log('working');
    return new Promise((resolve, reject) => {
      let users_collection;

      firebase.firestore().collection("users").doc(user_id).get().then(querySnapshot2 => {

        let user_data = querySnapshot2.data();

        console.log(user_id);
        firebase.firestore().collection("contact_details").where("uid", "==", user_id).get().then(function (details) {

          //console.log(detail);
          let contact_details = [];
          details.forEach(function (result) {
            //console.log(empDoc.data());
            let contact_data = result.data();
            contact_details.push(contact_data)

          })

          if (!user_data.allowCustoViewOnlyPermission) {
            user_data.allowCustoViewOnlyPermission = 0;
          }
          if (!user_data.allowCustoeditPermission) {
            user_data.allowCustoeditPermission = 0;
          }

          if (!user_data.accessGrantedFromUser) {
            user_data.accessGrantedFromUser = 0;
          }
          if (!user_data.accessPermission) {
            user_data.accessPermission = 0;
          }

          users_collection = {
            user_data: user_data,
            contact_details: contact_details[0]
          }

          resolve(users_collection);


        })

      })



    })

  }

  // get applicants details by email

  getApplicantDetailsByEmail(email_id) {

    // return new Promise((resolve, reject) => {
    //   let users_collection;

    //   firebase.firestore().collection("users").where("email", "==", email_id).get().then(querySnapshot2 => {

    //     let user_data;
    //     querySnapshot2.forEach(function (result) {
    //       //console.log(empDoc.data());
    //        user_data = result.data();
    //       //console.log(contact_data);
    //       //contact_details.push(contact_data)
    //      // resolve(contact_data);
    //     })
    //       firebase.firestore().collection("contact_details").where("uid", "==", user_data.uid).get().then(function (details) {

    //                   //console.log(detail);
    //                   let contact_details = [];
    //                   details.forEach(function (result) {
    //                     //console.log(empDoc.data());
    //                     let contact_data = result.data();
    //                     contact_details.push(contact_data)

    //                   })

    //                   users_collection = {
    //                     user_data: user_data,
    //                     contact_details: contact_details[0]
    //                   }

    //                   resolve(users_collection);


    //                 })

    //               })

    //     })

    return new Promise((resolve, reject) => {
      let users_collection;
      firebase.firestore().collection("users").where("email", "==", email_id).get().then(querySnapshot2 => {
        let users = [];
        querySnapshot2.forEach(function (result) {
          //console.log(empDoc.data());
          let user_data = result.data();
          users.push(user_data)
          //console.log(user_data);
          //console.log(contact_data);
          //contact_details.push(contact_data)
          // resolve(contact_data);
        })
        if (users.length > 0) {
          let uid = users[0].uid;
          firebase.firestore().collection("contact_details").where("uid", "==", uid).get().then(function (details) {
            //console.log(detail);
            let contact_details = [];
            details.forEach(function (result) {
              //console.log(empDoc.data());
              let contact_data = result.data();
              contact_details.push(contact_data)
            })
            if (contact_details.length > 0) {
              users_collection = {
                status: 'success',
                user_data: users[0],
                contact_details: contact_details[0]
              }
            }
            else {
              users_collection = {
                status: 'success',
                user_data: users[0],
                contact_details: contact_details
              }
            }
            resolve(users_collection);
          })
        }
        else {

          let message = 'User is not found';
          let result = {
            status: 'error',
            message: message
          }
          reject(result);
        }

      })

    })

  }

    // get applicants details by uid

    getApplicantDetailsById(uid) {

      // return new Promise((resolve, reject) => {
      //   let users_collection;

      //   firebase.firestore().collection("users").where("email", "==", email_id).get().then(querySnapshot2 => {

      //     let user_data;
      //     querySnapshot2.forEach(function (result) {
      //       //console.log(empDoc.data());
      //        user_data = result.data();
      //       //console.log(contact_data);
      //       //contact_details.push(contact_data)
      //      // resolve(contact_data);
      //     })
      //       firebase.firestore().collection("contact_details").where("uid", "==", user_data.uid).get().then(function (details) {

      //                   //console.log(detail);
      //                   let contact_details = [];
      //                   details.forEach(function (result) {
      //                     //console.log(empDoc.data());
      //                     let contact_data = result.data();
      //                     contact_details.push(contact_data)

      //                   })

      //                   users_collection = {
      //                     user_data: user_data,
      //                     contact_details: contact_details[0]
      //                   }

      //                   resolve(users_collection);


      //                 })

      //               })

      //     })

      return new Promise((resolve, reject) => {
        let users_collection;
        firebase.firestore().collection("users").where("uid", "==", uid).get().then(querySnapshot2 => {
          let users = [];
          querySnapshot2.forEach(function (result) {
            //console.log(empDoc.data());
            let user_data = result.data();
            users.push(user_data)
            //console.log(user_data);
            //console.log(contact_data);
            //contact_details.push(contact_data)
            // resolve(contact_data);
          })
          if (users.length > 0) {
            let uid = users[0].uid;
            firebase.firestore().collection("contact_details").where("uid", "==", uid).get().then(function (details) {
              //console.log(detail);
              let contact_details = [];
              details.forEach(function (result) {
                //console.log(empDoc.data());
                let contact_data = result.data();
                contact_details.push(contact_data)
              })
              if (contact_details.length > 0) {
                users_collection = {
                  status: 'success',
                  user_data: users[0],
                  contact_details: contact_details[0]
                }
              }
              else {
                users_collection = {
                  status: 'success',
                  user_data: users[0],
                  contact_details: contact_details
                }
              }
              resolve(users_collection);
            })
          }
          else {

            let message = 'User is not found';
            let result = {
              status: 'error',
              message: message
            }
            reject(result);
          }

        })

      })

    }




  // get all applicants contact list data

  getAllApplicantContact(limit, offset) {

    let total_data = limit * offset;


    return new Promise(function (resolve, reject) {

      firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).orderBy('created_date', 'desc').limit(total_data).get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let userlist = [];
          querySnapshot2.forEach(function (contDoc) {
            //console.log(empDoc.data());
            let contact_data = contDoc.data();
            contact_data.uid = contDoc.id;
            userlist.push(contact_data)


          })
          //console.log(employmentlist);

          resolve(userlist)

        })

    });


  }


  // getting employment and income details by sending sdf form id

  getEmploymentandIncomeBySDFId(SDF_form_document_id) {


    return new Promise(function (resolve, reject) {

      firebase.firestore().collection("employment").where("SDF_form", "==", SDF_form_document_id).get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let employmentlist = [];
          querySnapshot2.forEach(function (empDoc) {
            //console.log(empDoc.data());
            let employment_data = empDoc.data();
            employmentlist.push(employment_data)
          })
          //console.log(employmentlist);

          resolve(employmentlist)

        })

    }).then(function (employmentlist) { // (**)

      return new Promise((resolve, reject) => { // (*)

        firebase.firestore().collection("SDF_income").where("SDF_form", "==", SDF_form_document_id).get()
          .then(function (querySnapshot2) {
            let incomelist = [];
            querySnapshot2.forEach(function (incDoc) {
              //console.log(empDoc.data());
              let income_data = incDoc.data();
              incomelist.push(income_data)
            })
            let finalresult = {
              employmentlist: employmentlist,
              incomelist: incomelist
            }

            //return finalresult;
            resolve(finalresult)
          })
      });

    })

  }
  // getting assets and liability details by sending sdf form id

  getAssetsandLiabilityBySDFId(SDF_form_document_id) {


    return new Promise(function (resolve, reject) {

      firebase.firestore().collection("SDF_assets").where("SDF_form", "==", SDF_form_document_id).get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let assetslist = [];
          querySnapshot2.forEach(function (asstDoc) {
            //console.log(empDoc.data());
            let assets_data = asstDoc.data();
            assetslist.push(assets_data)
          })
          //console.log(employmentlist);

          resolve(assetslist)

        })

    }).then(function (assetslist) { // (**)

      return new Promise((resolve, reject) => { // (*)

        firebase.firestore().collection("SDF_liabilities").where("SDF_form", "==", SDF_form_document_id).get()
          .then(function (querySnapshot2) {
            let liabilitylist = [];
            querySnapshot2.forEach(function (liaDoc) {
              //console.log(empDoc.data());
              let liability_data = liaDoc.data();
              liabilitylist.push(liability_data)
            })
            let finalresult = {
              assetslist: assetslist,
              liabilitylist: liabilitylist
            }

            //return finalresult;
            resolve(finalresult)
          })
      });

    })

  }

  // getting realestate details by sending sdf form id

  getRealestateBySDFId(SDF_form_document_id) {


    return new Promise(function (resolve, reject) {

      firebase.firestore().collection("SDF_realestate").where("SDF_form", "==", SDF_form_document_id).get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let realestatelist = [];
          querySnapshot2.forEach(function (realDoc) {
            //console.log(empDoc.data());
            let realestae_data = realDoc.data();
            realestatelist.push(realestae_data)
          })
          //console.log(employmentlist);

          resolve(realestatelist)

        })

    })

  }

  get_first_user_data(SDF_form_document_id, uid) {
    return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
  }
  get_second_user_data(SDF_form_document_id) {
    return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('contact_type', '==', 'Secondary Contact').where('SDF_form_document_id', '==', SDF_form_document_id).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
  }

  get_users_table_data(email_id) {
    console.log(email_id);
    return this.db.collection<any>("users", ref => ref.where('created_date', '>', 0).where('email', '==', email_id).orderBy('created_date', 'desc')).valueChanges();
  }
  get_users_table_dataByPhone(phone_number) {
    return this.db.collection<any>("users", ref => ref.where('created_date', '>', 0).where('mobile_phone', '==', phone_number).orderBy('created_date', 'desc')).valueChanges();
  }

  // load applicant data
  loadAllApplicantData(endBefore, limit) {

    if (endBefore == '') {
      console.log('its working');
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).orderBy('created_date', 'desc').limit(limit).get().then((querySnapshot2) => {
          let userlist = [];
          querySnapshot2.forEach(function (contDoc) {
            //console.log(empDoc.data());
            let contact_data = contDoc.data();
            contact_data.uid = contDoc.id
            if (contact_data.deleted == 0) {
              userlist.push(contact_data)
            }


          })
          //console.log(employmentlist);

          resolve(userlist)

        });
      })
    }
    else {
      console.log('its not working');
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).orderBy('created_date', 'desc').limit(limit).startAfter(endBefore).get().then((querySnapshot2) => {
          let userlist = [];
          querySnapshot2.forEach(function (contDoc) {
            //console.log(empDoc.data());
            let contact_data = contDoc.data();
            contact_data.uid = contDoc.id
            if (contact_data.deleted == 0) {
              userlist.push(contact_data)
            }

            resolve(userlist)
          })

        });
      })

    }

  }

  updateuserpermissionbyid(user_id, allowCustoViewOnlyPermission, allowCustoeditPermission) {


    // user_id = 'FIvXEG36ETtth5uLBBgK';
    // allowCustoViewOnlyPermission=1;
    // allowCustoeditPermission=1;

    return new Promise((resolve, reject) => {
      //let users_collection;
      firebase.firestore().collection("users").doc(user_id).
        update({
          allowCustoViewOnlyPermission: allowCustoViewOnlyPermission,
          allowCustoeditPermission: allowCustoeditPermission
        }).then(function () {

          let status = 'success';
          let message = 'user is updated';

          let result = {
            status: status,
            message: message
          }
          resolve(result);

        })

    })

  }

  getspecificApplicationsById(adf_id) {

    return new Promise((resolve, reject) => {
      firebase.firestore().collection("adf_forms").where('adf_form_id', '==', adf_id).get().then(function (querySnapshot2) {

        let adf_details = [];
        querySnapshot2.forEach(function (result) {
          console.log(result.data());
          let adf_data = result.data();
          adf_details.push(adf_data)

        })

        resolve(adf_details);
      })


    })
  }
  getspecificcontacts() {
    let adf_id = 'OYs90nwJr1zAfzbkNYvC';

    return new Promise((resolve, reject) => {
      firebase.firestore().collection("adf_forms").doc(adf_id).get().then(function (querySnapshot2) {

        console.log(querySnapshot2.data());

        resolve(true);
      })


    })
  }

  checkdata(item) {
    if(item) {
      return item;
    }
    else {
      return '';
    }
  }

  // modify data for adf forms
  convertData(adf_data) {

    debugger;

   console.log('---------------',adf_data);
    let children_arr = [];
    let children_length = parseInt(adf_data.dependentAndFamilyFormValue.how_many_children);
    for (let i = 0; i < children_length; i++) {

      if (i == 0) {
        let children_object = {
          age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.first_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 1) {
        let children_object = {
          age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.second_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 2) {
        let children_object = {
          age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.third_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 3) {
        let children_object = {
          age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.fourth_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 4) {
        let children_object = {
          age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.fifth_child_age)
        }
        children_arr.push(children_object);
      }

    }

    let incomes = [];

    adf_data.incomeDetailFormValue.itemRows.forEach(incomelement => {

      let salary_arr = [];

      for (let i = 0; i <= 5; i++) {

        if (i == 0) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_0),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_0)
          }
          salary_arr.push(salary_object);
        }
        if (i == 1) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_1),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_1)
          }
          salary_arr.push(salary_object);
        }
        if (i == 2) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_2),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_2)
          }
          salary_arr.push(salary_object);
        }
        if (i == 3) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_3),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_3)
          }
          salary_arr.push(salary_object);
        }
        if (i == 4) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_4),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_4)
          }
          salary_arr.push(salary_object);
        }
        if (i == 5) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_5),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_5)
          }
          salary_arr.push(salary_object);
        }

      }

      let income = {
        SDF_form: this.replaceUndefinied(incomelement.SDF_form),
        amount: this.replaceUndefinied(incomelement.amount),
        any_other_allowances: this.replaceUndefinied(incomelement.any_other_allowances),
        comments:this.replaceUndefinied(incomelement.comments),
        created_date:this.replaceUndefinied(incomelement.created_date),
        date_commenced:this.replaceUndefinied(incomelement.date_commenced),
        deleted:0,
        document_id:this.replaceUndefinied(incomelement.document_id),
        frequency:this.replaceUndefinied(incomelement.frequency),
        receive_commissions_bounses:this.replaceUndefinied(incomelement.receive_commissions_bounses),
        receive_moter_vehicle_allowance:this.replaceUndefinied(incomelement.receive_moter_vehicle_allowance),
        receive_overtime:this.replaceUndefinied(incomelement.receive_overtime),
        salary:salary_arr,
        salary_sacrifice:this.replaceUndefinied(incomelement.salary_sacrifice),
        type:this.replaceUndefinied(incomelement.type),
        uid:this.replaceUndefinied(incomelement.uid),
        nature_of_business:this.replaceUndefinied(incomelement.nature_of_business),
        statusyourEmployment:this.replaceUndefinied(incomelement.statusyourEmployment),
        type_of_entity:this.replaceUndefinied(incomelement.type_of_entity),
        your_occupation:this.replaceUndefinied(incomelement.your_occupation)
      }

      incomes.push(income);

    });


    let previous_array = [
      {
        address_type: this.replaceUndefinied(adf_data.addressFormValue.address_type),
        address_format: this.replaceUndefinied(adf_data.addressFormValue.address_format),
        full_address: this.replaceUndefinied(adf_data.addressFormValue.full_address),
        floor_number: this.replaceUndefinied(adf_data.addressFormValue.floor_number),
        unit_number: this.replaceUndefinied(adf_data.addressFormValue.unit_number),
        building_name: this.replaceUndefinied(adf_data.addressFormValue.building_name),
        street_number: this.replaceUndefinied(adf_data.addressFormValue.street_number),
        street_name: this.replaceUndefinied(adf_data.addressFormValue.street_name),
        street_type: this.replaceUndefinied(adf_data.addressFormValue.street_type),
        poboxlabel: this.replaceUndefinied(adf_data.addressFormValue.poboxlabel),
        city: this.replaceUndefinied(adf_data.addressFormValue.city),
        state: this.replaceUndefinied(adf_data.addressFormValue.state),
        postcode: this.replaceUndefinied(adf_data.addressFormValue.postcode),
        country: this.replaceUndefinied(adf_data.addressFormValue.country),
        housing_situation: this.replaceUndefinied(adf_data.addressFormValue.housing_situation),
        move_in_date: this.replaceUndefinied(adf_data.addressFormValue.move_in_date),
        type: "current"
      },
    ];
    adf_data.addressFormValue.addPreviousAddressItem.forEach(element => {
      let add_obj = {
        deleted: element.deleted,
        address_format: this.replaceUndefinied(element.previous_address_format),
        address_type: this.replaceUndefinied(element.previous_address_type),
        building_name: this.replaceUndefinied(element.previous_building_name),
        city: this.replaceUndefinied(element.previous_city),
        country: this.replaceUndefinied(element.previous_country),
        floor_number: this.replaceUndefinied(element.previous_full_address),
        full_address: this.replaceUndefinied(element.previous_full_address),
        housing_situation: this.replaceUndefinied(element.previous_housing_situation),
        move_in_date: this.replaceUndefinied(element.previous_move_in_date),
        move_out_date: this.replaceUndefinied(element.previous_move_out_date),
        poboxlabel: this.replaceUndefinied(element.previous_poboxlabel),
        postcode: this.replaceUndefinied(element.previous_postcode),
        state: this.replaceUndefinied(element.previous_state),
        street_name: this.replaceUndefinied(element.previous_street_name),
        street_number: this.replaceUndefinied(element.previous_street_number),
        street_type: this.replaceUndefinied(element.previous_street_type),
        unit_number: this.replaceUndefinied(element.previous_unit_number),
        type: "previous"
      }

      previous_array.push(add_obj);

    });


    let primary_applicant_object = {
      user_data: {
        firstname:adf_data.primaryFormValue.firstname,
        lastname:adf_data.primaryFormValue.lastname,
        middlename:this.replaceUndefinied(adf_data.primaryFormValue.middlename),
        email: adf_data.primaryFormValue.email,
        mobile_phone: adf_data.primaryFormValue.mobile_phone,
        date_of_birth:adf_data.primaryFormValue.date_of_birth,
        reference_broker:adf_data.reference_broker,
        password: this.stringGen(12),
        allowCustoeditPermission:0,
        allowCustoViewOnlyPermission:0,
        deleted:0,
        created_date: new Date().getTime(),
        roles:{
          contact:true
        },
        uid:this.checkdata(adf_data.primaryFormValue.uid)
    },
    type:'primary',
      contact_details: {

        dependent: {

          gender: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.gender),
          current_marital_status: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.current_marital_status),
          do_you_have_children: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.do_you_have_children),
          how_many_children: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.how_many_children),
          children_age: children_arr
        },
        address: previous_array,
        employment_details:
        {
          employementType: this.replaceUndefinied(adf_data.employmentDetailFormValue.employementType),
          start_date: this.replaceUndefinied(adf_data.employmentDetailFormValue.start_date),
          currentlyEmployment: this.replaceUndefinied(adf_data.employmentDetailFormValue.currentlyEmployment),
          expectFindWork: this.replaceUndefinied(adf_data.employmentDetailFormValue.expectFindWork),
          statusyourEmployment: this.replaceUndefinied(adf_data.employmentDetailFormValue.statusyourEmployment),
          your_occupation: this.replaceUndefinied(adf_data.employmentDetailFormValue.your_occupation),
          business_name: this.replaceUndefinied(adf_data.employmentDetailFormValue.business_name),
          type_of_entity: this.replaceUndefinied(adf_data.employmentDetailFormValue.type_of_entity),
          addPrimaryEmploymentItem: this.replaceUndefinied(adf_data.employmentDetailFormValue.addPrimaryEmploymentItem),
          abn_acn: this.replaceUndefinied(adf_data.employmentDetailFormValue.abn_acn),
          nature_of_business: this.replaceUndefinied(adf_data.employmentDetailFormValue.nature_of_business),
          created_date: new Date().getTime(),
          deleted: 0,
          incomes: incomes,
        },

        uid: this.replaceUndefinied(adf_data.primary_contact_id),
        deleted: 0,
        created_date: new Date().getTime(),
        roles: {
          contact: true
        }
      }
    }


    let contacts = [];

    console.log(primary_applicant_object);

    contacts.push(primary_applicant_object);

    adf_data.primaryFormValue.addAnotherApplicantItem.forEach((element,index) => {


      let adchildren_arr = [];
      let children_length = parseInt(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].how_many_children);
      for (let i = 0; i < children_length; i++) {

        if (i == 0) {
          let children_object = {
            age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].first_child_age)
          }
          adchildren_arr.push(children_object);
        }
        if (i == 1) {
          let children_object = {
            age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].second_child_age)
          }
          adchildren_arr.push(children_object);
        }
        if (i == 2) {
          let children_object = {
            age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].third_child_age)
          }
          adchildren_arr.push(children_object);
        }
        if (i == 3) {
          let children_object = {
            age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].fourth_child_age)
          }
          adchildren_arr.push(children_object);
        }
        if (i == 4) {
          let children_object = {
            age: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].fifth_child_age)
          }
          adchildren_arr.push(children_object);
        }

      }

      let ad_incomes = [];

      if(adf_data.incomeDetailFormValue.addApplicantIncomeItem.length > 0) {
        adf_data.incomeDetailFormValue.addApplicantIncomeItem[index].itemRows.forEach(adincomelement => {

          let adsalary_arr = [];

          for (let i = 0; i <= 5; i++) {

            if (i == 0) {
              let salary_object = {
                payslip: this.replaceUndefinied(adincomelement.sallary_payslip_0),
                payslip_name: this.replaceUndefinied(adincomelement.sallary_payslip_name_0)
              }
              adsalary_arr.push(salary_object);
            }
            if (i == 1) {
              let salary_object = {
                payslip: this.replaceUndefinied(adincomelement.sallary_payslip_1),
                payslip_name: this.replaceUndefinied(adincomelement.sallary_payslip_name_1)
              }
              adsalary_arr.push(salary_object);
            }
            if (i == 2) {
              let salary_object = {
                payslip: this.replaceUndefinied(adincomelement.sallary_payslip_2),
                payslip_name: this.replaceUndefinied(adincomelement.sallary_payslip_name_2)
              }
              adsalary_arr.push(salary_object);
            }
            if (i == 3) {
              let salary_object = {
                payslip: this.replaceUndefinied(adincomelement.sallary_payslip_3),
                payslip_name: this.replaceUndefinied(adincomelement.sallary_payslip_name_3)
              }
              adsalary_arr.push(salary_object);
            }
            if (i == 4) {
              let salary_object = {
                payslip: this.replaceUndefinied(adincomelement.sallary_payslip_4),
                payslip_name: this.replaceUndefinied(adincomelement.sallary_payslip_name_4)
              }
              adsalary_arr.push(salary_object);
            }
            if (i == 5) {
              let salary_object = {
                payslip: this.replaceUndefinied(adincomelement.sallary_payslip_5),
                payslip_name: this.replaceUndefinied(adincomelement.sallary_payslip_name_5)
              }
              adsalary_arr.push(salary_object);
            }

          }

          let adincome = {
            SDF_form: this.replaceUndefinied(adincomelement.SDF_form),
            amount: this.replaceUndefinied(adincomelement.amount),
            any_other_allowances: this.replaceUndefinied(adincomelement.any_other_allowances),
            comments:this.replaceUndefinied(adincomelement.comments),
            created_date:this.replaceUndefinied(adincomelement.created_date),
            date_commenced:this.replaceUndefinied(adincomelement.date_commenced),
            deleted:0,
            document_id:this.replaceUndefinied(adincomelement.document_id),
            frequency:this.replaceUndefinied(adincomelement.frequency),
            receive_commissions_bounses:this.replaceUndefinied(adincomelement.receive_commissions_bounses),
            receive_moter_vehicle_allowance:this.replaceUndefinied(adincomelement.receive_moter_vehicle_allowance),
            receive_overtime:this.replaceUndefinied(adincomelement.receive_overtime),
            salary:adsalary_arr,
            salary_sacrifice:this.replaceUndefinied(adincomelement.salary_sacrifice),
            type:this.replaceUndefinied(adincomelement.type),
            uid:this.replaceUndefinied(adincomelement.uid),
            nature_of_business:this.replaceUndefinied(adincomelement.nature_of_business),
            statusyourEmployment:this.replaceUndefinied(adincomelement.statusyourEmployment),
            type_of_entity:this.replaceUndefinied(adincomelement.type_of_entity),
            your_occupation:this.replaceUndefinied(adincomelement.your_occupation)
          }

          ad_incomes.push(adincome);

        });
      }

      let addprevious_array =[];

      if(adf_data.addressFormValue.addAddressRelationshipItem.length > 0) {


        if(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_same_as_primary) {
          addprevious_array = previous_array;
          addprevious_array[0].same_as_primary = true;
        }
        else {

          addprevious_array = [
            {
              same_as_primary:false,
              address_type: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_address_type),
              address_format: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_address_format),
              full_address: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_full_address),
              floor_number: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_floor_number),
              unit_number: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_unit_number),
              building_name: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_building_name),
              street_number: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_street_number),
              street_name: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_street_name),
              street_type: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_street_type),
              poboxlabel: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_poboxlabel),
              city: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_city),
              state: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_state),
              postcode: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_postcode),
              country: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_country),
              housing_situation: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_housing_situation),
              move_in_date: this.replaceUndefinied(adf_data.addressFormValue.addAddressRelationshipItem[index].addi_move_in_date),
              type: "current"
            },
          ];
          adf_data.addressFormValue.addAddressRelationshipItem[index].addPAddressRelationshipItem.forEach(element => {
            let add_obj = {
              deleted: element.deleted,
              address_format: this.replaceUndefinied(element.addi_address_format),
              address_type: this.replaceUndefinied(element.addi_address_type),
              building_name: this.replaceUndefinied(element.addi_building_name),
              city: this.replaceUndefinied(element.addi_city),
              country: this.replaceUndefinied(element.addi_country),
              floor_number: this.replaceUndefinied(element.addi_floor_number),
              full_address: this.replaceUndefinied(element.addi_full_address),
              housing_situation: this.replaceUndefinied(element.addi_housing_situation),
              move_in_date: this.replaceUndefinied(element.addi_move_in_date),
              move_out_date: this.replaceUndefinied(element.addi_move_out_date),
              poboxlabel: this.replaceUndefinied(element.addi_poboxlabel),
              postcode: this.replaceUndefinied(element.addi_postcode),
              state: this.replaceUndefinied(element.addi_state),
              street_name: this.replaceUndefinied(element.addi_street_name),
              street_number: this.replaceUndefinied(element.addi_street_number),
              street_type: this.replaceUndefinied(element.addi_street_type),
              unit_number: this.replaceUndefinied(element.addi_unit_number),
              type: "previous"
            }

            console.log(add_obj)

            addprevious_array.push(add_obj);

          });

        }
        //debugger;
        console.log(addprevious_array);

      }
      else {
        addprevious_array = [];
      }
      let ademployment_details;

      if(adf_data.employmentDetailFormValue.addEmploymentItem.length > 0) {

        ademployment_details = {
          employementType: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].employementType),
          start_date: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].start_date),
          currentlyEmployment: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].currentlyEmployment),
          expectFindWork: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].expectFindWork),
          statusyourEmployment: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].statusyourEmployment),
          your_occupation: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].your_occupation),
          business_name: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].business_name),
          type_of_entity: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].type_of_entity),
          previousEmploymentItem: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].previousEmploymentItem),
          abn_acn: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].abn_acn),
          nature_of_business: this.replaceUndefinied(adf_data.employmentDetailFormValue.addEmploymentItem[index].nature_of_business),
          created_date: new Date().getTime(),
          deleted: 0,
          incomes: ad_incomes,
        }
      }
      else {
        ademployment_details = {}
      }


      let secondary_applicant_object = {
        user_data: {
          firstname:this.replaceUndefinied(adf_data.primaryFormValue.addAnotherApplicantItem[index].secondary_firstname),
          lastname:this.replaceUndefinied(adf_data.primaryFormValue.addAnotherApplicantItem[index].secondary_lastname),
          middlename:this.replaceUndefinied(adf_data.primaryFormValue.addAnotherApplicantItem[index].secondary_middlename),
          email: this.replaceUndefinied(adf_data.primaryFormValue.addAnotherApplicantItem[index].secondary_email),
          mobile_phone: this.replaceUndefinied(adf_data.primaryFormValue.addAnotherApplicantItem[index].secondary_mobile_phone),
          date_of_birth: this.replaceUndefinied(adf_data.primaryFormValue.addAnotherApplicantItem[index].secondary_date_of_birth),
          password: this.stringGen(12),
          allowCustoeditPermission:0,
          allowCustoViewOnlyPermission:0,
          reference_broker:adf_data.reference_broker,
          deleted:0,
          created_date: new Date().getTime(),
          roles:{
            contact:true
          },
          uid:this.checkdata(adf_data.primaryFormValue.addAnotherApplicantItem[index].uid)
      },
      type:'additional',
        contact_details: {

          dependent: {

            gender: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].gender),
            current_marital_status: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].current_marital_status),
            do_you_have_children: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].do_you_have_children),
            how_many_children: this.replaceUndefinied(adf_data.dependentAndFamilyFormValue.addFamilyItem[index].how_many_children),
            children_age: adchildren_arr
          },
          address: addprevious_array,
          employment_details:ademployment_details,

          uid:this.checkdata(adf_data.primaryFormValue.addAnotherApplicantItem[index].uid),
          deleted: 0,
          created_date: new Date().getTime(),
          roles: {
            contact: true
          }
        }
      }

      contacts.push(secondary_applicant_object);

    });

    let adf_objects = {
      adf_form_id:  this.checkdata(adf_data.adf_form_id),
      primary_contact_id:this.checkdata(adf_data.primary_contact_id),
      reference_broker:this.replaceUndefinied(adf_data.primaryFormValue.reference_broker),
      primayr_goal_intention:this.replaceUndefinied(adf_data.primaryGoalFormValue.primayr_goal_intention),
      contacts:contacts,
      assets:adf_data.assertsFormValue.itemRowsAssets,
      liabilities: adf_data.liabilityFormValue.itemRowsLiabilities,
      realestate:adf_data.realEstateFormValue.itemRowsRealEstates,
      user_ids:[],
      application_status:'open',
      deleted:0,
      title:this.replaceUndefinied(adf_data.primaryFormValue.title),
      created_date: new Date().getTime(),
      keywords:[]
    }

    return adf_objects;

  }

  saveADFForm(upcomingobject = '') {

    console.log(upcomingobject);
    // convertion of data
    let adf_objects = this.convertData(upcomingobject);

    console.log(adf_objects);
    debugger;
    let thiss = this;

    //saving applicants details if it is not exists

    return new Promise(function (resolve, reject) {


      let contacts = [];
      let user_ids = [];

      const requests = adf_objects.contacts.map(function (data) {

        // check if the email is already exists or not
        const promise = new Promise(function (resolve, reject) {

          data.user_data.reference_broker = adf_objects.reference_broker;

          thiss.checkuserexist(data.user_data).then((result: any) => {


            // if not exists then create new applicants contacts
            // resolve(true);
                //if (!result.status) {
                  console.log(result);
                  console.log(status);
                  let user_id = result.uid;
                  user_ids.push(user_id);
                  let newuser:any;
                  if (!result.status) {
                     newuser = data.user_data;
                  }
                  else {
                     newuser = data.user_data;
                     console.log(result.users.allowCustoViewOnlyPermission);
                     console.log(result.users.allowCustoeditPermission);
                     if(result.users.allowCustoeditPermission) {
                      newuser.allowCustoeditPermission = result.users.allowCustoeditPermission;
                     }
                     else {
                      newuser.allowCustoeditPermission = 0;
                     }
                     if(result.users.allowCustoViewOnlyPermission) {
                      newuser.allowCustoViewOnlyPermission = result.users.allowCustoViewOnlyPermission;
                     }
                     else {
                      newuser.allowCustoViewOnlyPermission = 0;
                     }
                      // newuser.allowCustoeditPermission = result.users.allowCustoeditPermission;
                      newuser.password = result.users.password;
                  }


                  console.log(newuser);
                  newuser.reference_broker = adf_objects.reference_broker;
                  newuser.uid = user_id;

                  let keywordNameWithUser = thiss.createKeywords(`${newuser.firstname.toLowerCase()} ${newuser.lastname.toLowerCase()}`);
                  let keywordLastNameWithUser = thiss.createKeywords(`${newuser.lastname.toLowerCase()}`);


                    const keywordNameWithEmail = thiss.createKeywords(`${newuser.email.toLowerCase()}`);
                    //var c = keywordNameWithUser.concat(keywordNameWithEmail);

                    const keywordNameWithPhone = thiss.createKeywords(`${newuser.mobile_phone}`);
                    let keywordNameWithBroker;
                    let keywordLastNameWithBroker;
                    if(result.broker_data) {
                      keywordNameWithBroker = thiss.createKeywords(`${result.broker_data.firstname.toLowerCase()} ${result.broker_data.lastname.toLowerCase()}`);
                      keywordLastNameWithBroker = thiss.createKeywords(`${result.broker_data.lastname.toLowerCase()}`);
                    }
                    else {
                      keywordNameWithBroker = []
                      keywordLastNameWithBroker = []
                    }


                    let final_keyword_list = [...keywordNameWithUser,...keywordNameWithEmail,...keywordNameWithPhone,...keywordNameWithBroker,...keywordLastNameWithBroker,...keywordLastNameWithUser];



                    var d = final_keyword_list.filter((item, pos) => final_keyword_list.indexOf(item) === pos)

                    newuser.keywords = d;

                  if (data.type == 'primary') {
                    console.log(adf_objects);
                    adf_objects.primary_contact_id = user_id;

                    let keywordNameWithStatus = thiss.createKeywords(`${adf_objects.application_status.toLowerCase()}`);

                    let keywordNameWithTitle = thiss.createKeywords(`${adf_objects.title.toLowerCase()}`);
                    let todayd = new Date(adf_objects.created_date);

                   let dateobj = ('0' + todayd.getDate()).slice(-2) + '/'
                          + ('0' + (todayd.getMonth()+1)).slice(-2) + '/'
                          + todayd.getFullYear();
                     console.log(dateobj);

                    let keywordNameWithDate = thiss.createKeywords(`${dateobj}`);



                    let final_keyword_adflist = [...keywordNameWithUser,...keywordNameWithBroker,...keywordNameWithStatus,...keywordNameWithTitle,...keywordNameWithDate,...keywordLastNameWithUser,...keywordLastNameWithBroker];
                    console.log(final_keyword_list);

                      var filteradfdata = final_keyword_adflist.filter((item, pos) => final_keyword_adflist.indexOf(item) === pos)
                      adf_objects.keywords = filteradfdata;
                  }


                  return new Promise((resolve,reject)=>{

                    firebase.firestore().collection("users").doc(user_id).set(newuser).then(function (querySnapshot2) {

                      resolve(true);

                    })
                  }).then(()=>{

                    return new Promise((childresolve,reject)=>{

                      if (data.contact_details) {
                        data.contact_details.uid = user_id;
                          console.log('its is okay');

                            // firebase.firestore().collection("contact_details").add(data.contact_details).then(function (details) {
                           firebase.firestore().collection("contact_details").where('uid','==',user_id).get().then(function (querySnapshot3) {
                              console.log('sdsd');

                              let flag = 0;

                              querySnapshot3.forEach(function (contDoc) {
                                flag = 1;
                                contDoc.ref.update(data.contact_details);
                              })
                              if (flag == 0) {
                                firebase.firestore().collection("contact_details").add(data.contact_details).then(function (details) {

                                })
                              }
                              data.user_data.uid =  user_id;
                              contacts.push(data);
                              adf_objects.contacts = contacts;

                                resolve(true)
                            })

                      }
                      else {
                          data.user_data.uid =  user_id;

                          contacts.push(data);
                          adf_objects.contacts = contacts;

                         //resolve(adf_objects)

                           resolve(true)
                        }

                    })

                  }).then(()=>{
                    console.log('fina;l');
                    resolve(true);
                  })


                //}
                // else {


                //         if(data.type == 'primary') {
                //           console.log('working');
                //           console.log(data.user_data);
                //           adf_objects.primary_contact_id = result.uid;
                //           console.log(adf_objects);
                //         }
                //           console.log('user else');
                //           data.user_data.password = result.password;
                //           console.log(result.password);
                //           data.user_data.uid = result.uid;
                //           user_ids.push(result.uid);
                //           contacts.push(data);
                //           //adf_objects.contacts = contacts;
                //           // console.log(adf_objects);
                //           resolve(true);


                //     }


          })
        })

        return promise;

      });

      Promise.all(requests).then(function (result) {
        console.log('all promiseall')
         console.log(contacts)
         console.log(user_ids);
         adf_objects.contacts = contacts;
         adf_objects.user_ids = user_ids;
         console.log(adf_objects);
        // let newadf_objects = adf_objects;
        resolve(adf_objects);
      })

    }).then(function (adf_objects: any) {

      console.log(adf_objects);
      debugger;
      if (adf_objects.adf_form_id == '') {

        console.log('working');
        return new Promise((resolve, reject) => {

          firebase.firestore().collection("adf_forms").add(adf_objects)
            .then(function (docRef) {

              console.log('within then');

              let adf_id = docRef.id;
              adf_objects.adf_form_id = adf_id;
              // adf_objects.primary_contact_id = adf_objects.contacts[0].user_data.uid;
              let newADFForm = adf_objects;
              firebase.firestore().collection("adf_forms").doc(adf_id).set(newADFForm).then(function (querySnapshot2) {

                firebase.firestore().collection("analytics").where('id','==',1).get().then(function (querySnapshot3) {
                  querySnapshot3.forEach(function (anaDoc) {

                    anaDoc.ref.update({
                      total_adf:firebase.firestore.FieldValue.increment(1)
                    });
                  })

                  let finalresult = {
                    message: 'New ADF form is created successfully',
                    adf_id: adf_id,
                    primary_contact_id: adf_objects.primary_contact_id,
                    status: 'success'
                  }
                  resolve(finalresult);

                })

              })

            })

        })

      }
      else {
        console.log('not working');
        return new Promise((resolve, reject) => {

          firebase.firestore().collection("adf_forms").doc(adf_objects.adf_form_id).set(adf_objects).then(function (querySnapshot2) {
            let finalresult = {
              message: 'New ADF form is created successfully',
              adf_id: adf_objects.adf_form_id,
              primary_contact_id: adf_objects.primary_contact_id,
              status: 'success'
            }
            resolve(finalresult);
          })

        })
      }

    });
  }

  createKeywords = name => {
    const arrName = [];
    let curName = '';
    name.split('').forEach(letter => {
      curName += letter;
      arrName.push(curName);
    });
    return arrName;
  }


  getAllAdfForm(limit,offset) {
    let total_data = limit * offset;

    if(limit !== '' && offset!=='') {
      return new Promise(function (resolve, reject) {

        firebase.firestore().collection("adf_forms").where('deleted', '==', 0).orderBy('created_date', 'desc').limit(total_data).get()
          .then(function (querySnapshot2) {
            console.log(querySnapshot2);
            let userlist = [];
            querySnapshot2.forEach(function (contDoc) {
              //console.log(empDoc.data());
              let contact_data = contDoc.data();
              contact_data.uid = contDoc.id;
              userlist.push(contact_data)


            })
            //console.log(employmentlist);

            resolve(userlist)

          })

      });
    }
    else{

      return new Promise(function (resolve, reject) {

        firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).orderBy('created_date', 'desc').get()
          .then(function (querySnapshot2) {
            console.log(querySnapshot2);
            let userlist = [];
            querySnapshot2.forEach(function (contDoc) {
              //console.log(empDoc.data());
              let contact_data = contDoc.data();
              contact_data.uid = contDoc.id;
              userlist.push(contact_data)


            })
            //console.log(employmentlist);

            resolve(userlist)

          })

      });
    }
  }

  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }

  updaterealstate(adf_id,newrealstate) {
    console.log(adf_id);
    console.log(newrealstate);
    return new Promise((resolve,reject) =>{

      firebase.firestore().collection("adf_forms").where('adf_form_id', '==', adf_id).get().then(querySnapshot2 => {
        querySnapshot2.forEach((doc) => {
          doc.ref.update({ realestate: newrealstate });
        });

        let new_status = {
          status:'success',
          message:'realestate updated successfully'
        }
        resolve(new_status);
      })
    })
  }

  updateAdfEditPermission(data) {

    console.log(data);
    debugger;
    return new Promise((resolve,reject) =>{

      firebase.firestore().collection("adf_forms").where('adf_form_id', '==', data.SDF_form_document_id).get().then(querySnapshot2 => {
        querySnapshot2.forEach((doc) => {

          console.log(doc.data());
          let adf_data = doc.data();
          let contacts = [];

          adf_data.contacts.forEach(contact => {
              if(contact.user_data.uid == data.contact_uid) {
                  contact.user_data.allowCustoeditPermission = data.allowCustoeditPermission
              }
              contacts.push(contact);
          });

          doc.ref.update({
            contacts: contacts
          });
        });

        let new_status = {
          status:'success',
          message:'realestate updated successfully'
        }
        resolve(new_status);
      })
    })
  }

  updateAdfViewPermission(data) {
    console.log(data);
    debugger;
    return new Promise((resolve,reject) =>{

      firebase.firestore().collection("adf_forms").where('adf_form_id', '==', data.SDF_form_document_id).get().then(querySnapshot2 => {
        querySnapshot2.forEach((doc) => {

          console.log(doc.data());
          let adf_data = doc.data();
          let contacts = [];

          adf_data.contacts.forEach(contact => {
              if(contact.user_data.uid == data.contact_uid) {
                  contact.user_data.allowCustoViewOnlyPermission = data.allowCustoViewOnlyPermission
              }
              contacts.push(contact);
          });

          doc.ref.update({
            contacts: contacts
          });
        });

        let new_status = {
          status:'success',
          message:'realestate updated successfully'
        }
        resolve(new_status);
      })
    })
  }

  update_adf_status(adf_id,status) {

    console.log(adf_id);

    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("adf_forms").where('adf_form_id', '==', adf_id).get().then(querySnapshot2 => {
        querySnapshot2.forEach((doc) => {

          console.log(doc.data());
          let adf_data = doc.data();

          if(!status) {
            doc.ref.update({
              application_status: 'closed'
            });
          }
          else {
            doc.ref.update({
              application_status: 'open'
            });
          }


          })
          let new_status = {
            status:'success',
            message:'status updated successfully'
          }
          resolve(new_status);

        });
    })

  }
  saveuserarray()
  {
    return new Promise((resolve,reject)=>{

          firebase.firestore().collection("adf_forms").get().then(function (querySnapshot2) {

            let adf_datas = [];

            querySnapshot2.forEach(function (result) {
              //console.log(empDoc.data());
              let users_ids = [];

              let adf_data = result.data();

              adf_data.contacts.forEach(contact => {

                let user_id = contact.user_data.uid;
                  users_ids.push(user_id)
              });

              adf_data.user_ids = users_ids

              adf_datas.push(adf_data);
              //resolve(true);
              result.ref.update({
                user_ids: users_ids
              });
            })

            resolve(adf_datas);
        })


    })

  }

  getusersdata() {
    return new Promise((resolve,reject) =>{
      firebase.firestore().collection("users_data").get().then(function (querySnapshot2) {

        let sdf_datas = [];

        querySnapshot2.forEach(function (result) {
          //console.log(empDoc.data());
          let adf_data = result.data();

            sdf_datas.push(adf_data);

        })
        resolve(sdf_datas);

      })
    }).then((adf_data:any)=>{
          console.log(adf_data);

          let result = [];

          return new Promise((resolve,reject)=>{

            const requests = adf_data.map(function (adfitem) {

              const promise = new Promise(function (resolve, reject) {



                firebase.firestore().collection("users").where('uid','==',adfitem.uid).get().then(function (userdetailsSnapshot) {
                  userdetailsSnapshot.forEach((userdetailsdoc) => {
                    let user_data = userdetailsdoc.data();

                    adfitem.user_info = user_data;
                    //console.log("Document 2 successfully deleted!");
                    let count = 1;

                    firebase.firestore().collection("users_info").add(adfitem).then((docRef)=>{

                              console.log(count);
                              count = count +1;
                              resolve(true);
                    })

                  });


                })
              })
              return promise;
          });

            Promise.all(requests).then(function (newresult) {
              //console.log(finalexams);
                  console.log(result);
                  resolve(result);
            })


          })

      })


  }

  getusersinfo(user_data) {

    return new Promise((resolve,reject) => {

      firebase.firestore().collection("users").where('uid','==',user_data.uid).get().then(function (userdetailsSnapshot) {
        userdetailsSnapshot.forEach((userdetailsdoc) => {
          let user_data = userdetailsdoc.data();
            resolve(user_data);
        });
      })

    })

  }


  savenewadf() {
    let thiss = this;

    return new Promise((resolve,reject) =>{
      firebase.firestore().collection("SDF_form").get().then(function (querySnapshot2) {

        let sdf_datas = [];

        querySnapshot2.forEach(function (result) {
          //console.log(empDoc.data());
          let adf_data = result.data();

            sdf_datas.push(adf_data);

        })
        resolve(sdf_datas);

      })
    }).then((adf_data:any)=>{
          console.log(adf_data);

          let result = [];

          return new Promise((resolve,reject)=>{

            const requests = adf_data.map(function (adfitem) {

              const promise = new Promise(function (resolve, reject) {

                let users_data_array = [];

                firebase.firestore().collection("users_info").where('SDF_form_document_id','==',adfitem.id).get().then(function (userdetailsSnapshot) {
                  userdetailsSnapshot.forEach((userdetailsdoc) => {
                    let user_data = userdetailsdoc.data();
                    users_data_array.push(user_data)
                    //console.log("Document 2 successfully deleted!");
                  });

                    adfitem.users_data = users_data_array;
                    //console.log(adfitem);
                    result.push(adfitem);

                    resolve(true);
                })
              })
              return promise;
          });

            Promise.all(requests).then(function (newresult) {
              //console.log(finalexams);
                  console.log(result);
                  resolve(result);
            })


          })
          .then((adf_data:any)=>{

            let result = [];

            return new Promise((resolve,reject)=>{

              const requests = adf_data.map(function (adfitem) {

                const promise = new Promise(function (resolve, reject) {

                  let users_emp_array = [];

                  firebase.firestore().collection("employment").where('SDF_form','==',adfitem.id).get().then(function (userdetailsSnapshot) {
                    userdetailsSnapshot.forEach((userdetailsdoc) => {
                      let user_data = userdetailsdoc.data();
                      users_emp_array.push(user_data)
                      //console.log("Document 2 successfully deleted!");
                    });

                      adfitem.employment = users_emp_array;
                      //console.log(adfitem);
                      result.push(adfitem);

                      resolve(true);
                  })
                })
                return promise;
            });

              Promise.all(requests).then(function (newresult) {
                //console.log(finalexams);
                    console.log(result);
                    resolve(result);
              })


          })
          .then((adf_data:any)=>{

            let result = [];

            return new Promise((resolve,reject)=>{

              const requests = adf_data.map(function (adfitem) {

                const promise = new Promise(function (resolve, reject) {

                  let users_asset_array = [];

                  firebase.firestore().collection("SDF_assets").where('SDF_form','==',adfitem.id).get().then(function (userdetailsSnapshot) {
                    userdetailsSnapshot.forEach((userdetailsdoc) => {
                      let user_data = userdetailsdoc.data();
                      users_asset_array.push(user_data)
                      //console.log("Document 2 successfully deleted!");
                    });

                      adfitem.assets = users_asset_array;
                      //console.log(adfitem);
                      result.push(adfitem);

                      resolve(true);
                  })
                })
                return promise;
            });

              Promise.all(requests).then(function (newresult) {
                //console.log(finalexams);
                    console.log(result);
                    resolve(result);
              })


            })
            .then((adf_data:any)=>{

              let result = [];

              return new Promise((resolve,reject)=>{

                const requests = adf_data.map(function (adfitem) {

                  const promise = new Promise(function (resolve, reject) {

                    let users_asset_array = [];

                    firebase.firestore().collection("SDF_liabilities").where('SDF_form','==',adfitem.id).get().then(function (userdetailsSnapshot) {
                      userdetailsSnapshot.forEach((userdetailsdoc) => {
                        let user_data = userdetailsdoc.data();
                        users_asset_array.push(user_data)
                        //console.log("Document 2 successfully deleted!");
                      });

                        adfitem.liabilities = users_asset_array;
                        //console.log(adfitem);
                        result.push(adfitem);

                        resolve(true);
                    })
                  })
                  return promise;
              });

                Promise.all(requests).then(function (newresult) {
                  //console.log(finalexams);
                      console.log(result);
                      resolve(result);
                })


              })
              .then((adf_data:any)=>{

                let result = [];

                return new Promise((resolve,reject)=>{

                  const requests = adf_data.map(function (adfitem) {

                    const promise = new Promise(function (resolve, reject) {

                      let users_asset_array = [];

                      firebase.firestore().collection("SDF_realestate").where('SDF_form','==',adfitem.id).get().then(function (userdetailsSnapshot) {
                        userdetailsSnapshot.forEach((userdetailsdoc) => {
                          let user_data = userdetailsdoc.data();
                          users_asset_array.push(user_data)
                          //console.log("Document 2 successfully deleted!");
                        });

                          adfitem.realestate = users_asset_array;
                          //console.log(adfitem);
                          result.push(adfitem);

                          resolve(true);
                      })
                    })
                    return promise;
                });

                  Promise.all(requests).then(function (newresult) {
                    //console.log(finalexams);
                        console.log(result);
                        resolve(result);
                  })


                })


              .then((adf_data:any)=>{

                let result = [];

                return new Promise((resolve,reject)=>{

                  const requests = adf_data.map(function (adfitem) {

                    const promise = new Promise(function (resolve, reject) {

                      let users_asset_array = [];

                      firebase.firestore().collection("SDF_income").where('SDF_form','==',adfitem.id).get().then(function (userdetailsSnapshot) {
                        userdetailsSnapshot.forEach((userdetailsdoc) => {
                          let user_data = userdetailsdoc.data();
                          users_asset_array.push(user_data)
                          //console.log("Document 2 successfully deleted!");
                        });

                          adfitem.incomes = users_asset_array;
                          //console.log(adfitem);
                          result.push(adfitem);

                          resolve(true);
                      })
                    })
                    return promise;
                  });

                  Promise.all(requests).then(function (newresult) {
                    //console.log(finalexams);
                        console.log(result);
                        resolve(result);
                  })


                })
                .then((newadf_data:any)=>{

                  console.log(newadf_data);

                  let result = [];
                  let contacts_array = [];

                   adf_data.map(function (adfitem) {

                    //let newadfitem = adfitem.toObject();


                      let convert_adfdata = thiss.convertnewData(adfitem);

                          convert_adfdata.contacts.forEach(contactitem => {

                            contacts_array.push(contactitem.contact_details);
                          });
                        console.log(convert_adfdata);
                        //debugger;
                        result.push(convert_adfdata);
                        //resolve(true);

                      });

                      let final_result = {
                        contacts:contacts_array,
                        adf_data:result
                      }
                    return final_result;

                })

                // .then((adf_data:any)=>{
                //   console.log(adf_data);
                // })
                .then((adf_data:any) =>{

                  console.log(adf_data);
                  return new Promise((resolve,reject)=>{
                    let count = 0;

                    const requests = adf_data.contacts.map(function (contactitem) {

                        console.log(count);
                        count = count + 1;

                          const promise = new Promise(function (resolve, reject) {
                            firebase.firestore().collection("contact_details").add(contactitem).then((docRef)=>{

                            })

                          })
                          return promise;
                      });
                    })
                  })

                // .then((adf_data:any)=>{

                //   console.log(adf_data);
                //   return new Promise((resolve,reject)=>{
                //     let count = 0;

                //     const requests = adf_data.adf_data.map(function (adfitem) {

                //         console.log(count);
                //         count = count + 1;
                //           //console.log(contactitem);
                //           const promise = new Promise(function (resolve, reject) {
                //             firebase.firestore().collection("adf_forms").add(adfitem).then((queryresult)=>{
                //               let adfid = queryresult.id;
                //                 adfitem.adf_form_id = queryresult.id;
                //                 let newadf = adfitem;
                //                 firebase.firestore().collection("adf_forms").doc(adfid).set(newadf).then((queryresult)=>{
                //                   console.log(count);

                //                   count = count + 1;
                //                   resolve(true);

                //                 })

                //             })

                //           })
                //           return promise;
                //       });

                //       Promise.all(requests).then(function (newresult) {
                //         //console.log(finalexams);
                //             console.log(adf_data);
                //             resolve(adf_data);
                //       })

                //     })

                // })



                })
              })

              })

            })

          })
        })

      //})

  }

  convertnewData(adf_data:any) {

    let primary_children_arr = [];
    let additional_children_arr = [];
    let thiss = this;

    adf_data.users_data.forEach(useritem => {

        if(useritem.uid == adf_data.uid) {

          let children_length = parseInt(useritem.how_many_children);
          for (let i = 0; i < children_length; i++) {

            if (i == 0) {
              let children_object = {
                age: thiss.replaceUndefinied(useritem.first_child_age)
              }
              primary_children_arr.push(children_object);
            }
            if (i == 1) {
              let children_object = {
                age: thiss.replaceUndefinied(useritem.second_child_age)
              }
              primary_children_arr.push(children_object);
            }
            if (i == 2) {
              let children_object = {
                age: thiss.replaceUndefinied(useritem.third_child_age)
              }
              primary_children_arr.push(children_object);
            }
            if (i == 3) {
              let children_object = {
                age: thiss.replaceUndefinied(useritem.fourth_child_age)
              }
              primary_children_arr.push(children_object);
            }
            if (i == 4) {
              let children_object = {
                age: thiss.replaceUndefinied(useritem.fifth_child_age)
              }
              primary_children_arr.push(children_object);
            }

          }


        }
        else {

        }

    });
    let primary_incomes = [];
    let additional_incomes = [];
    let primary_salary_arr = [];
    let additional_salary_arr = [];


    adf_data.incomes.forEach(incomelement => {

       if(incomelement.uid == adf_data.uid) {

        for (let i = 0; i <= 5; i++) {

          if (i == 0) {

            if(incomelement.sallary_payslip_name_0 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_0),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_0)
              }
              primary_salary_arr.push(salary_object);

            }

          }
          if (i == 1) {

            if(incomelement.sallary_payslip_name_1 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_1),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_1)
              }
              primary_salary_arr.push(salary_object);

            }

          }
          if (i == 2) {

            if(incomelement.sallary_payslip_name_2 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_2),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_2)
              }
              primary_salary_arr.push(salary_object);

            }

          }
          if (i == 3) {

            if(incomelement.sallary_payslip_name_3 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_3),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_3)
              }
              primary_salary_arr.push(salary_object);

            }

          }
          if (i == 4) {

            if(incomelement.sallary_payslip_name_4 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_4),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_4)
              }
              primary_salary_arr.push(salary_object);

            }

          }
          if (i == 5) {

            if(incomelement.sallary_payslip_name_5 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_5),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_5)
              }
              primary_salary_arr.push(salary_object);

            }

          }

        }

        let income = {
          SDF_form: thiss.replaceUndefinied(incomelement.SDF_form),
          amount: '$ '+thiss.formatMoney(incomelement.amount),
          any_other_allowances: '$ '+thiss.formatMoney(incomelement.any_other_allowances),
          comments:thiss.replaceUndefinied(incomelement.comments),
          created_date:thiss.replaceUndefinied(incomelement.created_date),
          date_commenced:thiss.replaceUndefinied(incomelement.date_commenced),
          deleted:0,
          document_id:thiss.replaceUndefinied(incomelement.document_id),
          frequency:thiss.replaceUndefinied(incomelement.frequency),
          receive_commissions_bounses:'$ '+thiss.formatMoney(incomelement.receive_commissions_bounses),
          receive_moter_vehicle_allowance: '$ '+thiss.formatMoney(incomelement.receive_moter_vehicle_allowance),
          receive_overtime:'$ '+thiss.formatMoney(incomelement.receive_overtime),
          salary:primary_salary_arr,
          salary_sacrifice:'$ '+thiss.formatMoney(incomelement.salary_sacrifice),
          type:thiss.replaceUndefinied(incomelement.type),
          uid:thiss.replaceUndefinied(incomelement.uid),
          nature_of_business:thiss.replaceUndefinied(incomelement.nature_of_business),
          statusyourEmployment:thiss.replaceUndefinied(incomelement.statusyourEmployment),
          type_of_entity:thiss.replaceUndefinied(incomelement.type_of_entity),
          your_occupation:thiss.replaceUndefinied(incomelement.your_occupation)
        }

        primary_incomes.push(income);

       }
       else {

        for (let i = 0; i <= 5; i++) {

          if (i == 0) {

            if(incomelement.sallary_payslip_name_0 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_0),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_0)
              }
              additional_salary_arr.push(salary_object);

            }

          }
          if (i == 1) {

            if(incomelement.sallary_payslip_name_1 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_1),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_1)
              }
              additional_salary_arr.push(salary_object);

            }

          }
          if (i == 2) {

            if(incomelement.sallary_payslip_name_2 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_2),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_2)
              }
              additional_salary_arr.push(salary_object);

            }

          }
          if (i == 3) {

            if(incomelement.sallary_payslip_name_3 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_3),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_3)
              }
              additional_salary_arr.push(salary_object);

            }

          }
          if (i == 4) {

            if(incomelement.sallary_payslip_name_4 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_4),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_4)
              }
              additional_salary_arr.push(salary_object);

            }

          }
          if (i == 5) {

            if(incomelement.sallary_payslip_name_5 !== 0) {

              let salary_object = {
                payslip: thiss.replaceUndefinied(incomelement.sallary_payslip_5),
                payslip_name: thiss.replaceUndefinied(incomelement.sallary_payslip_name_5)
              }
              additional_salary_arr.push(salary_object);

            }

          }

        }

        let income = {
          SDF_form: thiss.replaceUndefinied(incomelement.SDF_form),
          amount: '$ '+thiss.formatMoney(incomelement.amount),
          any_other_allowances: '$ '+thiss.formatMoney(incomelement.any_other_allowances),
          comments:thiss.replaceUndefinied(incomelement.comments),
          created_date:thiss.replaceUndefinied(incomelement.created_date),
          date_commenced:thiss.replaceUndefinied(incomelement.date_commenced),
          deleted:0,
          document_id:thiss.replaceUndefinied(incomelement.document_id),
          frequency:thiss.replaceUndefinied(incomelement.frequency),
          receive_commissions_bounses:'$ '+thiss.formatMoney(incomelement.receive_commissions_bounses),
          receive_moter_vehicle_allowance:'$ '+thiss.formatMoney(incomelement.receive_moter_vehicle_allowance),
          receive_overtime:'$ '+thiss.formatMoney(incomelement.receive_overtime),
          salary:additional_salary_arr,
          salary_sacrifice:'$ '+thiss.formatMoney(incomelement.salary_sacrifice),
          type:thiss.replaceUndefinied(incomelement.type),
          uid:thiss.replaceUndefinied(incomelement.uid),
          nature_of_business:thiss.replaceUndefinied(incomelement.nature_of_business),
          statusyourEmployment:thiss.replaceUndefinied(incomelement.statusyourEmployment),
          type_of_entity:thiss.replaceUndefinied(incomelement.type_of_entity),
          your_occupation:thiss.replaceUndefinied(incomelement.your_occupation)
        }

        additional_incomes.push(income);

       }

    });

    //console.log(additional_incomes);

    let primary_employment = {};
    let additional_employment = [];

    adf_data.employment.forEach((employmentelement,empIndex) => {

      if(employmentelement.uid == adf_data.uid) {
        let addPrimaryEmploymentItem;

        if(employmentelement.addPrimaryEmploymentItem) {
           addPrimaryEmploymentItem = employmentelement.addPrimaryEmploymentItem.map((obj)=> {return Object.assign({}, obj)});
        }
        else {
           addPrimaryEmploymentItem = {};
        }


        primary_employment =
        {
          employementType: thiss.replaceUndefinied(employmentelement.employementType),
          start_date: thiss.replaceUndefinied(employmentelement.start_date),
          currentlyEmployment: thiss.replaceUndefinied(employmentelement.currentlyEmployment),
          expectFindWork: thiss.replaceUndefinied(employmentelement.expectFindWork),
          statusyourEmployment: thiss.replaceUndefinied(employmentelement.statusyourEmployment),
          your_occupation: thiss.replaceUndefinied(employmentelement.your_occupation),
          business_name: thiss.replaceUndefinied(employmentelement.business_name),
          type_of_entity: thiss.replaceUndefinied(employmentelement.type_of_entity),
          addPrimaryEmploymentItem: addPrimaryEmploymentItem,
          abn_acn: thiss.replaceUndefinied(employmentelement.abn_acn),
          nature_of_business: thiss.replaceUndefinied(employmentelement.nature_of_business),
          created_date: thiss.replaceUndefinied(employmentelement.created_date),
          deleted: 0,
          incomes: primary_incomes,
        }
      }
      else {
        let addincomes = [];
         additional_incomes.forEach(addincome => {
           if(addincome.uid == employmentelement.uid) {
            addincomes.push(addincome);
           }

         });

         let previousEmploymentItem;

         if(employmentelement.addEmploymentItem) {
            previousEmploymentItem = employmentelement.addEmploymentItem[empIndex].previousEmploymentItem.map((obj)=> {return Object.assign({}, obj)});
         }
         else {
            previousEmploymentItem = {};
         }


         let addit_employment =
         {
           employementType: thiss.replaceUndefinied(employmentelement.employementType),
           start_date: thiss.replaceUndefinied(employmentelement.start_date),
           currentlyEmployment: thiss.replaceUndefinied(employmentelement.currentlyEmployment),
           expectFindWork: thiss.replaceUndefinied(employmentelement.expectFindWork),
           statusyourEmployment: thiss.replaceUndefinied(employmentelement.statusyourEmployment),
           your_occupation: thiss.replaceUndefinied(employmentelement.your_occupation),
           business_name: thiss.replaceUndefinied(employmentelement.business_name),
           type_of_entity: thiss.replaceUndefinied(employmentelement.type_of_entity),
           previousEmploymentItem: previousEmploymentItem,
           abn_acn: thiss.replaceUndefinied(employmentelement.abn_acn),
           nature_of_business: thiss.replaceUndefinied(employmentelement.nature_of_business),
           created_date: thiss.replaceUndefinied(employmentelement.created_date),
           uid:thiss.replaceUndefinied(employmentelement.uid),
           deleted: 0,
           incomes: addincomes,
         }
         additional_employment.push(addit_employment);

      }
    });

    console.log(additional_employment);

    let contacts = [];
    let adf_rreference = '';
    let primayr_goal_intention = '';
    let user_ids = [];
    let firstname = '';
    let lastname = '';


    adf_data.users_data.forEach((userelement:any) => {

       //debugger;
      if(userelement.uid == adf_data.uid) {

        let previous_array = [
          {
            address_type: thiss.checkolddata(userelement.address_type),
            address_format: thiss.checkolddata(userelement.address_format),
            full_address: thiss.checkolddata(userelement.full_address),
            floor_number: thiss.checkolddata(userelement.floor_number),
            unit_number: thiss.checkolddata(userelement.unit_number),
            building_name: thiss.checkolddata(userelement.building_name),
            street_number: thiss.checkolddata(userelement.street_number),
            street_name: thiss.checkolddata(userelement.street_name),
            street_type: thiss.checkolddata(userelement.street_type),
            poboxlabel: thiss.checkolddata(userelement.poboxlabel),
            city: thiss.checkolddata(userelement.city),
            state: thiss.checkolddata(userelement.state),
            postcode: thiss.checkolddata(userelement.postcode),
            country: thiss.checkolddata(userelement.country),
            housing_situation: thiss.checkolddata(userelement.housing_situation),
            move_in_date: thiss.checkolddata(userelement.move_in_date),

            type: "current"
          },
        ];

        if(userelement.addPreviousAddressItem) {

          userelement.addPreviousAddressItem.forEach(element => {
            let add_obj = {
              deleted: element.deleted,
              address_format: thiss.checkolddata(element.previous_address_format),
              address_type: thiss.checkolddata(element.previous_address_type),
              building_name: thiss.checkolddata(element.previous_building_name),
              city: thiss.checkolddata(element.previous_city),
              country: thiss.checkolddata(element.previous_country),
              floor_number: thiss.checkolddata(element.previous_full_address),
              full_address: thiss.checkolddata(element.previous_full_address),
              housing_situation: thiss.checkolddata(element.previous_housing_situation),
              move_in_date: thiss.checkolddata(element.previous_move_in_date),
              move_out_date: thiss.checkolddata(element.previous_move_out_date),
              poboxlabel: thiss.checkolddata(element.previous_poboxlabel),
              postcode: thiss.checkolddata(element.previous_postcode),
              state: thiss.checkolddata(element.previous_state),
              street_name: thiss.checkolddata(element.previous_street_name),
              street_number: thiss.checkolddata(element.previous_street_number),
              street_type: thiss.checkolddata(element.previous_street_type),
              unit_number: thiss.checkolddata(element.previous_unit_number),
              type: "previous"
            }

            previous_array.push(add_obj);

          });

        }

        adf_rreference = thiss.replaceUndefinied(userelement.reference_broker);
        primayr_goal_intention = thiss.replaceUndefinied(userelement.primayr_goal_intention);
        user_ids.push(userelement.uid);
         firstname = thiss.replaceUndefinied(userelement.user_info.firstname);
          if(firstname == '') {
            firstname = thiss.replaceUndefinied(userelement.firstname);
          }

         lastname = thiss.replaceUndefinied(userelement.user_info.lastname);

        if(lastname == '') {
          lastname = thiss.replaceUndefinied(userelement.lastname);
        }
        let email = thiss.replaceUndefinied(userelement.user_info.email);

        if(email == '') {
          email = thiss.replaceUndefinied(userelement.email);
        }

        let mobile_phone = thiss.replaceUndefinied(userelement.user_info.mobile_phone);

        if(mobile_phone == '') {
          mobile_phone = thiss.replaceUndefinied(userelement.mobile_phone);
        }
        let date_of_birth = thiss.replaceUndefinied(userelement.user_info.date_of_birth);

        if(date_of_birth == '') {
          date_of_birth = thiss.replaceUndefinied(userelement.date_of_birth);
        }

        let password = thiss.replaceUndefinied(userelement.user_info.password);

        if(password == '') {
          password = thiss.replaceUndefinied(userelement.password);
        }

        console.log(userelement.user_info)
        let primary_applicant_object = {
          user_data: {
            firstname:thiss.replaceUndefinied(firstname),
            lastname:thiss.replaceUndefinied(lastname),
            email: thiss.replaceUndefinied(email),
            mobile_phone: thiss.replaceUndefinied(mobile_phone),
            date_of_birth:thiss.replaceUndefinied(date_of_birth),
            reference_broker:thiss.replaceUndefinied(userelement.reference_broker),
            password: thiss.replaceUndefinied(password),
            allowCustoeditPermission:0,
            allowCustoViewOnlyPermission:0,
            deleted:0,
            created_date: new Date().getTime(),
            roles:{
              contact:true
            },
            uid:thiss.checkdata(userelement.uid)
        },
        type:'primary',
          contact_details: {

            dependent: {

              gender: thiss.replaceUndefinied(userelement.gender),
              current_marital_status: thiss.replaceUndefinied(userelement.current_marital_status),
              do_you_have_children: thiss.replaceUndefinied(userelement.do_you_have_children),
              how_many_children: thiss.replaceUndefinied(userelement.how_many_children),
              children_age: primary_children_arr
            },
            address: previous_array,
            employment_details: primary_employment,
            uid: thiss.replaceUndefinied(adf_data.uid),
            deleted: 0,
            created_date: thiss.replaceUndefinied(userelement.created_date),
            roles: {
              contact: true
            }
          }
        }

        contacts.push(primary_applicant_object);

       }
       else {

        let addprevious_array = [];

          if(userelement.same_as_primary) {
            adf_data.users_data.forEach((userelementsame:any) => {
              if(userelementsame.uid == adf_data.uid) {

                let addprevadd =
                  {

                    address_type: thiss.checkolddata(userelementsame.address_type),
                    address_format: thiss.checkolddata(userelementsame.address_format),
                    full_address: thiss.checkolddata(userelementsame.full_address),
                    floor_number: thiss.checkolddata(userelementsame.floor_number),
                    unit_number: thiss.checkolddata(userelementsame.unit_number),
                    building_name: thiss.checkolddata(userelementsame.building_name),
                    street_number: thiss.checkolddata(userelementsame.street_number),
                    street_name: thiss.checkolddata(userelementsame.street_name),
                    street_type: thiss.checkolddata(userelementsame.street_type),
                    poboxlabel: thiss.checkolddata(userelementsame.poboxlabel),
                    city: thiss.checkolddata(userelementsame.city),
                    state: thiss.checkolddata(userelementsame.state),
                    postcode: thiss.checkolddata(userelementsame.postcode),
                    country: thiss.checkolddata(userelementsame.country),
                    housing_situation: thiss.checkolddata(userelementsame.housing_situation),
                    move_in_date: thiss.checkolddata(userelementsame.move_in_date),
                    same_as_primary:true,
                    type: "current"
                  }

                  addprevious_array.push(addprevadd);

                if(userelementsame.addPreviousAddressItem) {

                  userelementsame.addPreviousAddressItem.forEach(element => {
                    let add_obj = {
                      deleted: element.deleted,
                      address_format: thiss.checkolddata(element.previous_address_format),
                      address_type: thiss.checkolddata(element.previous_address_type),
                      building_name: thiss.checkolddata(element.previous_building_name),
                      city: thiss.checkolddata(element.previous_city),
                      country: thiss.checkolddata(element.previous_country),
                      floor_number: thiss.checkolddata(element.previous_full_address),
                      full_address: thiss.checkolddata(element.previous_full_address),
                      housing_situation: thiss.checkolddata(element.previous_housing_situation),
                      move_in_date: thiss.checkolddata(element.previous_move_in_date),
                      move_out_date: thiss.checkolddata(element.previous_move_out_date),
                      poboxlabel: thiss.checkolddata(element.previous_poboxlabel),
                      postcode: thiss.checkolddata(element.previous_postcode),
                      state: thiss.checkolddata(element.previous_state),
                      street_name: thiss.checkolddata(element.previous_street_name),
                      street_number: thiss.checkolddata(element.previous_street_number),
                      street_type: thiss.checkolddata(element.previous_street_type),
                      unit_number: thiss.checkolddata(element.previous_unit_number),
                      type: "previous"
                    }

                    addprevious_array.push(add_obj);

                  });

                }


              }
            })
             //addprevious_array[0].same_as_primary = true;
          }
          else {

             addprevious_array = [
              {
                address_type: thiss.checkolddata(userelement.address_type),
                address_format: thiss.checkolddata(userelement.address_format),
                full_address: thiss.checkolddata(userelement.full_address),
                floor_number: thiss.checkolddata(userelement.floor_number),
                unit_number: thiss.checkolddata(userelement.unit_number),
                building_name: thiss.checkolddata(userelement.building_name),
                street_number: thiss.checkolddata(userelement.street_number),
                street_name: thiss.checkolddata(userelement.street_name),
                street_type: thiss.checkolddata(userelement.street_type),
                poboxlabel: thiss.checkolddata(userelement.poboxlabel),
                city: thiss.checkolddata(userelement.city),
                state: thiss.checkolddata(userelement.state),
                postcode: thiss.checkolddata(userelement.postcode),
                country: thiss.checkolddata(userelement.country),
                housing_situation: thiss.checkolddata(userelement.housing_situation),
                move_in_date: thiss.checkolddata(userelement.move_in_date),
                type: "current"
              },
            ];
            if(userelement.addPreviousAddressItem) {
              userelement.addPreviousAddressItem.forEach(element => {
                let add_obj = {
                  deleted: 0,
                  address_format: thiss.checkolddata(element.previous_address_format),
                  address_type: thiss.checkolddata(element.previous_address_type),
                  building_name: thiss.checkolddata(element.previous_building_name),
                  city: thiss.checkolddata(element.previous_city),
                  country: thiss.checkolddata(element.previous_country),
                  floor_number: thiss.checkolddata(element.previous_full_address),
                  full_address: thiss.checkolddata(element.previous_full_address),
                  housing_situation: thiss.checkolddata(element.previous_housing_situation),
                  move_in_date: thiss.checkolddata(element.previous_move_in_date),
                  move_out_date: thiss.checkolddata(element.previous_move_out_date),
                  poboxlabel: thiss.checkolddata(element.previous_poboxlabel),
                  postcode: thiss.checkolddata(element.previous_postcode),
                  state: thiss.checkolddata(element.previous_state),
                  street_name: thiss.checkolddata(element.previous_street_name),
                  street_number: thiss.checkolddata(element.previous_street_number),
                  street_type: thiss.checkolddata(element.previous_street_type),
                  unit_number: thiss.checkolddata(element.previous_unit_number),
                  type: "previous"
                }

                addprevious_array.push(add_obj);

              });
            }

          }

          //debugger;

        let children_length = parseInt(userelement.how_many_children);
        for (let i = 0; i < children_length; i++) {

          if (i == 0) {
            let children_object = {
              age: thiss.replaceUndefinied(userelement.first_child_age)
            }
            additional_children_arr.push(children_object);
          }
          if (i == 1) {
            let children_object = {
              age: thiss.replaceUndefinied(userelement.second_child_age)
            }
            additional_children_arr.push(children_object);
          }
          if (i == 2) {
            let children_object = {
              age: thiss.replaceUndefinied(userelement.third_child_age)
            }
            additional_children_arr.push(children_object);
          }
          if (i == 3) {
            let children_object = {
              age: thiss.replaceUndefinied(userelement.fourth_child_age)
            }
            additional_children_arr.push(children_object);
          }
          if (i == 4) {
            let children_object = {
              age: thiss.replaceUndefinied(userelement.fifth_child_age)
            }
            additional_children_arr.push(children_object);
          }

        }

        user_ids.push(userelement.uid);
        let addemployment = {};
        additional_employment.forEach(empelement => {
            if(empelement.uid == userelement.uid) {
               addemployment = empelement;
            }
            else {
              addemployment = {};
            }
            // console.log('avd');
        });

        let adfirstname = thiss.replaceUndefinied(userelement.user_info.firstname);
        if(adfirstname == '') {
          adfirstname = thiss.replaceUndefinied(userelement.firstname);
        }

      let adlastname = thiss.replaceUndefinied(userelement.user_info.lastname);

      if(adlastname == '') {
        adlastname = thiss.replaceUndefinied(userelement.lastname);
      }
      let email = thiss.replaceUndefinied(userelement.user_info.email);

      if(email == '') {
        email = thiss.replaceUndefinied(userelement.email);
      }

      let mobile_phone = thiss.replaceUndefinied(userelement.user_info.mobile_phone);

      if(mobile_phone == '') {
        mobile_phone = thiss.replaceUndefinied(userelement.mobile_phone);
      }
      let date_of_birth = thiss.replaceUndefinied(userelement.user_info.date_of_birth);

      if(date_of_birth == '') {
        date_of_birth = thiss.replaceUndefinied(userelement.date_of_birth);
      }

      let password = thiss.replaceUndefinied(userelement.user_info.password);

      if(password == '') {
        password = thiss.replaceUndefinied(userelement.password);
      }

        let additional_applicant_object = {
          user_data: {
            firstname:  thiss.replaceUndefinied(adfirstname),
            lastname: thiss.replaceUndefinied(adlastname),
            email: thiss.replaceUndefinied(email),
            mobile_phone: thiss.replaceUndefinied(mobile_phone),
            date_of_birth:thiss.replaceUndefinied(date_of_birth),
            reference_broker:thiss.replaceUndefinied(userelement.reference_broker),
            password: thiss.replaceUndefinied(password),
            allowCustoeditPermission:0,
            allowCustoViewOnlyPermission:0,
            deleted:0,
            created_date: new Date().getTime(),
            roles:{
              contact:true
            },
            uid:this.checkdata(userelement.uid)
        },
        type:'additional',
          contact_details: {

            dependent: {

              gender: thiss.replaceUndefinied(userelement.gender),
              current_marital_status: thiss.replaceUndefinied(userelement.current_marital_status),
              do_you_have_children: thiss.replaceUndefinied(userelement.do_you_have_children),
              how_many_children: thiss.replaceUndefinied(userelement.how_many_children),
              children_age: additional_children_arr
            },
            address: addprevious_array,
            employment_details: addemployment,
            uid: thiss.replaceUndefinied(userelement.uid),
            deleted: 0,
            created_date: thiss.replaceUndefinied(userelement.created_date),
            roles: {
              contact: true
            }
          }
        }

        contacts.push(additional_applicant_object);

       }

    });


    let assets = [];
     adf_data.assets.map((obj)=> {

      obj.asset_value = '$ '+thiss.formatMoney(obj.asset_value);
      obj.percentage_asset = '$ '+thiss.formatMoney(obj.percentage_asset);
      obj.description = thiss.checkolddata(obj.description);
      assets.push(obj);
    });

    let new_contacts = contacts.map((obj)=> {return Object.assign({}, obj)});

    let liabilities = [];
    adf_data.liabilities.map((obj)=> {
      obj.current_balance = '$ '+thiss.formatMoney(obj.current_balance);
      obj.limit = '$ '+thiss.formatMoney(obj.limit);
      obj.description = thiss.checkolddata(obj.description);
      liabilities.push(obj);
    });

    let realestates = [];

      adf_data.realestate.map((obj)=> {
        if(obj.secondary_percentage_asset == null) {
              console.log('yes');
              obj.secondary_percentage_asset = 0;
            }
            //obj.asset_value = '$ '+thiss.formatMoney(obj.asset_value);

            obj.address_type = thiss.checkolddata(obj.address_type);
            obj.address_format= thiss.checkolddata(obj.address_format);
            obj.full_address= thiss.checkolddata(obj.full_address);
            obj.floor_number= thiss.checkolddata(obj.floor_number);
            obj.unit_number= thiss.checkolddata(obj.unit_number);
            obj.building_name= thiss.checkolddata(obj.building_name);
            obj.street_number= thiss.checkolddata(obj.street_number);
            obj.street_name= thiss.checkolddata(obj.street_name);
            obj.street_type= thiss.checkolddata(obj.street_type);
            obj.poboxlabel= thiss.checkolddata(obj.poboxlabel);
            obj.city= thiss.checkolddata(obj.city);
            obj.state= thiss.checkolddata(obj.state);
            obj.postcode= thiss.checkolddata(obj.postcode);
            obj.country= thiss.checkolddata(obj.country);
            obj.housing_situation= thiss.checkolddata(obj.housing_situation);
            obj.move_in_date= thiss.checkolddata(obj.move_in_date);
            obj.notes= thiss.checkolddata(obj.notes);
            // console.log(obj);
            // debugger;
            realestates.push(obj);
        });




    let adf_objects = {
      adf_form_id:  thiss.checkdata(adf_data.uid),
      primary_contact_id:thiss.checkdata(adf_data.uid),
      reference_broker:thiss.replaceUndefinied(adf_rreference),
      primayr_goal_intention:thiss.replaceUndefinied(primayr_goal_intention),
      contacts:new_contacts,
      assets:assets,
      liabilities: liabilities,
      realestate: realestates,
      user_ids:user_ids,
      application_status:'closed',
      deleted:0,
      title:'OLD ADF – '+firstname+ ' '+lastname,
      created_date: new Date().getTime()
    }

    // console.log(adf_objects);
    // debugger;

    return adf_objects;

  }
  getalladfforms() {
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("adf_forms").get().then(function (querySnapshot2) {

         let adf_data = [];

        querySnapshot2.forEach((adfdetailsdoc) => {
          let a_data = adfdetailsdoc.data();
         adf_data.push(a_data);
        });

        resolve(adf_data);
       })

    })
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {

    }
  }

  getspecificUserEventsById(user_id) {
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("user_events").where('uid','==',user_id).get().then(function (querySnapshot2) {

        querySnapshot2.forEach((eventdetailsdoc) => {
          let user_events = eventdetailsdoc.data();
            resolve(user_events);
        });

       })

    })
  }
  updatealladfbyid(user_id) {
    return new Promise((resolve,reject)=>{

      firebase.firestore().collection("users").doc(user_id).get().then(querySnapshot2 => {

        let new_user = querySnapshot2.data();

        console.log(user_id);
        firebase.firestore().collection("contact_details").where("uid", "==", user_id).get().then(function (details) {

          //console.log(detail);
          let newcontact_details = [];
          details.forEach(function (result) {
            //console.log(empDoc.data());
            let contact_data = result.data();
            newcontact_details.push(contact_data)

          })

          firebase.firestore().collection("adf_forms").where('primary_contact_id','==',user_id).get().then(function (querySnapshot2) {

                  let adf_data = [];

                  querySnapshot2.forEach((adfdetailsdoc) => {
                    let a_data = adfdetailsdoc.data();
                      let all_contacts = [];

                      a_data.contacts.forEach(contactelement => {
                          if(contactelement.user_data.uid == user_id) {
                            contactelement.user_data = new_user;
                            contactelement.contact_details = newcontact_details[0];
                          }
                          all_contacts.push(contactelement);
                      });

                        adfdetailsdoc.ref.update({
                          contacts:all_contacts
                        });
                        adf_data.push(a_data);

                  });

                  firebase.firestore().collection("user_events").where('uid','==',user_id).get().then(function (querySnapshot2) {

                    querySnapshot2.forEach((eventdetailsdoc) => {
                      eventdetailsdoc.ref.update({
                        event_status:1
                      })
                    });

                    resolve(adf_data);

                  })


            })


        })

      })

    })
  }
  updatespecificUserEventsById(user_id) {
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("user_events").where('uid','==',user_id).get().then(function (querySnapshot2) {

        querySnapshot2.forEach((eventdetailsdoc) => {
          let user_events = eventdetailsdoc.data();
              eventdetailsdoc.ref.update({
                event_status:1
              })
            resolve(user_events);
        });

       })

    })
  }

  saveProfile(user_id,link){
    debugger;
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("users").where('uid','==',user_id).get().then(function (querySnapshot2) {

        querySnapshot2.forEach((eventdetailsdoc) => {
          let user_events = eventdetailsdoc.data();
            eventdetailsdoc.ref.update({
              imagelink:link
            })
            resolve(true);
        });

       })

    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/adf-page/services/adf-form.service.ts